
import Vue from 'vue'
import objectPath from 'object-path'
import initialStateHotel from './initialState'
import { cloningAnObject } from '@/utils/helpers'

const mutations = {
  clearHotelsState(state) {
    state.hotels = []
  },
  setHotelInitial(state) {
    state.hotels.push(initialStateHotel())
  },
  updateHotel(state, { data: info, query: form, hotelIndex }) {
    let hotel = cloningAnObject(state.hotels[hotelIndex])

    hotel = {
      ...hotel,
      info: {
        ...hotel.info,
        ...info
      },
      form: {
        ...hotel.form,
        ...form
      },
      isLoading: false
    }

    Vue.set(state.hotels, hotelIndex, hotel)
  },
  setHotelAccommodations(state, payload) {
    const {
      searchId,
      results: collection,
      filters,
      hotelIndex
    } = payload

    const current = collection.length ? collection[0] : initialStateHotel().accommodations.current

    const hotel = cloningAnObject(state.hotels[hotelIndex])

    hotel.accommodations = {
      ...hotel.accommodations,
      isLoading: false,
      current,
      searchId,
      collection
    }

    hotel.serviceLoaded = true

    hotel.collectionFilters = {
      ...hotel.collectionFilters,
      ...filters
    }

    Vue.set(state.hotels, hotelIndex, hotel)
    this.commit('cart/setRoomIdInTourists', { hotelIndex })
  },
  selectAccommodation(state, { hotelIndex, accommodationId }) {
    const accommodation = state.hotels[hotelIndex].accommodations.collection
      .find(x => x.id === accommodationId)

    state.hotels[hotelIndex].accommodations.current = {
      ...state.hotels[hotelIndex].accommodations.current,
      ...accommodation
    }

    this.commit('cart/setRoomIdInTourists', { hotelIndex })
  },
  setRoomIdInTourists(state, { hotelIndex }) {
    const accommodationRooms = state.hotels[hotelIndex].accommodations.current.room
    let formRooms = state.hotels[hotelIndex].form.rooms
    if (!Array.isArray(formRooms)) {
      formRooms = Object.keys(formRooms).map(key => formRooms[key])
    }
    const touristsForm = state.touristsForm
    let touristsOffset = 0

    if (accommodationRooms.length === formRooms.length) {
      formRooms.forEach((formRoom, formRoomIndex) => {
        const totalTouristsInRoom = formRoom.adults + formRoom.children
        const accommodationRoomId = accommodationRooms[formRoomIndex].id

        for (let i = 0; i < totalTouristsInRoom; i++) {
          touristsForm[touristsOffset + i].roomId = accommodationRoomId
        }

        touristsOffset += totalTouristsInRoom
      })
    }
  },
  setHotelTariffConditions(state, { hotelIndex, tariffConditions }) {
    objectPath.set(state, `hotels.${hotelIndex}.tariffConditions`, {
      ...objectPath.get(state, `hotels.${hotelIndex}.tariffConditions`),
      ...tariffConditions,
      isLoading: false
    })
  },
  setHotelsPenalties(state, { target, penalties }) {
    objectPath.set(state, `${target}.penalties`, {
      ...objectPath.get(state, `${target}.penalties`),
      isLoading: false,
      collection: penalties
    })
  },
}

export default mutations